<!--
 * @Description:
 * @Date: 2019-03-15 10:04:20
 -->
<!--用户管理-->
<template>
  <div class="table-box">
    <searchbar :searchEvent="searchEvent.bind(this)" :parent="this" />
    <!--列表-->
    <div>
      <el-table
        style="width: 100%"
        v-loading="loading"
        row-key="id"
        ref="recordList"
        :data="tableData"
        :stripe="false"
        :highlight-current-row="false"
        header-row-class-name="noBorder"
      >
        <!-- <el-table-column
          type="selection"
          width="55"
          row-key="id"
          :reserve-selection="true"
        ></el-table-column> -->
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="80"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="enterpriseName"
          label="企业"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="projectName"
          label="项目"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="hospital"
          label="医院"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="department"
          label="科室"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="visitAddress"
          label="定位"
        >
          <template slot-scope="scope">
            北纬N{{ scope.row.visitLatitude }},东经E{{
              scope.row.visitLongitude
            }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="meetingMinute"
          label="会议时长"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="meetingDt"
          label="会议时间"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="customerFeedback"
          label="客户反馈"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="signCount"
          label="签到人数"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="定位图片"
        >
          <template slot-scope="scope">
            <img
              :src="scope.row.addressPicUrl"
              v-amplifyImg="scope.row.addressPicUrl"
              v-if="scope.row.addressPicUrl"
            />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="状态"
        >
          <template slot-scope="scope">
            {{ scope.row.auditGongyeStatus | transAuditStatus }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <!-- <el-button type="text" size="small" @click="check(scope.row)">查看</el-button> -->
            <el-button
              :disabled="scope.row.auditGongyeStatus !== 1"
              type="text"
              size="small"
              @click="approve(2, scope.row)"
            >
              通过
            </el-button>
            <rejectComponent
              :disabled="scope.row.auditGongyeStatus !== 1"
              @withdraw="item => approve(3, scope.row, 0, item)"
            />
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="check(scope.row)">查看</el-button>
            <el-button
              type="text"
              size="small"
              @click="pass(scope,2)"
              :disabled="scope.row.auditStatus!=1"
            >通过</el-button>
            <el-button
              type="text"
              size="small"
              @click="pass(scope,3)"
              :disabled="scope.row.auditStatus!=1"
            >不通过</el-button>
          </template>
        </el-table-column>-->
      </el-table>
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationData.pageNum"
        :total="totalElements"
        :page-size="paginationData.pageSize"
        layout="total, prev, pager, next, jumper"
        style="padding:15px"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { project, receive } from '@/api/ajax';
import { pageInation } from '@/Mixin/listMixin';
import { initSearch } from '@/Mixin/initSearch';
import { makeSure } from '@/Mixin/makeSure';
import dicSelect from '@/components/Common/dicSelect.vue';
import taskRecordHandles from '@/Mixin/taskRecordHandles';
import searchbar from '@/components/Survey/searchbar';
import rejectComponent from '@/components/Task/components/reject.vue';
import OpenNewWin from '@/tools/openNewWin';
import approvalFlagMixins from '@/Mixin/approvalFlagMixins';

export default {
  mixins: [
    pageInation,
    makeSure,
    taskRecordHandles,
    initSearch,
    approvalFlagMixins
  ],
  data() {
    return {
      ruleForm: {}, // 用户信息
      getList: project.departmentVisitPlanList, // 获取列表的AJAX
      searchQuery: {
        projectId: this.$route.query.projectId,
        taskMonth: this.$route.query.month,
        statementId: this.$route.query.statementId
      },
      searchAjax: project.crmProjectList,
      prop: {
        label: 'projectName',
        code: 'id'
      },
      extraObj: {
        type: 3
      }
    };
  },
  components: {
    dicSelect,
    searchbar,
    rejectComponent
  },
  computed: {},
  methods: {
    exportEvent() {
      //导出
      if (this.searchQuery.projectId && this.searchQuery.taskMonth) {
        let queryString = this.$querystring.stringify(this.searchQuery);
        window.open(project.exportDepartmentVisitPlanExcel + '?' + queryString);
      } else {
        this.$message.error('请选择条件');
      }
    },
    check(row) {
      this.$router.push({
        name: 'kshRecordAddEdit',
        query: {
          id: row.id
        }
      });
    },

    saveEnterpriseId(val) {
      //保存
      this.searchQuery.enterpriseId = val.id;
    },
    saveProId(val) {
      this.searchQuery.projectId = val.id;
    },

    pass(scope, status) {
      let delEvent = scope => {
        let { $index, row } = scope;
        ksh
          .updateDepartmentMeetVisitAuditStatus({
            id: row.id,
            status
          })
          .then(res => {
            this.$notify({
              title: '成功',
              message: '操作成功',
              type: 'success'
            });
            this.initWatchRouteChange();
          });
      };
      this.makeSureEvent(delEvent, scope);
    }
  },

  created() {}
};
</script>
<style lang="scss" scoped>
.table-box {
  margin: 0;
}
</style>
